<template>
  <div class="customer-satisfaction mb-1 important">
    <div class="ratings flex py-2 px-0 justify-center important">
      <button
        v-for="rating in ratings"
        :key="rating.value"
        :class="buttonClass(rating)"
        @click="onClick(rating)"
      >
        {{ rating.value }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedRating: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      ratings: Array.from({ length: 10 }, (_, i) => ({
        value: i + 1,
        color: this.getColor(i + 1),
      })),
    };
  },
  methods: {
    getColor(value) {
      if (value >= 1 && value <= 6) return 'bg-red-500';
      if (value === 7 || value === 8) return 'bg-yellow-500';
      return 'bg-green-500';
    },
    buttonClass(rating) {
      return [
        rating.color,
        { selected: rating.value === this.selectedRating },
        { unselected: this.selectedRating !== null && rating.value !== this.selectedRating },
        'number-button shadow-none text-xl lg:text-2xl outline-none mx-1 text-white py-1 px-2 rounded-md important',
      ];
    },
    onClick(rating) {
      this.$emit('selectRating', rating.value);
    },
  },
};
</script>

<style scoped>
.customer-satisfaction {
  margin-bottom: 0.1rem;
}

.ratings {
  display: flex;
  padding: 0.5rem 0;
  justify-content: center;
}

.number-button {
  transition: transform 300ms, opacity 300ms;
  opacity: 1;
  background-color: var(--color);
  color: white;
  font-size: 1.25rem;
  line-height: 1.75rem;
  outline: none;
  margin: 0 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  box-shadow: none;
  }
  .selected {
      transform: scale(1.1);
      opacity: 1 !important;
    }
    .unselected {
      transform: scale(0.9);
      opacity: 0.5;
    }

.bg-red-500 {
  background-color: #f56565;
}

.bg-yellow-500 {
  background-color: #ecc94b;
}

.bg-green-500 {
  background-color: #48bb78;
}
</style>